<template>
<div>
        <div class="relic columns">
        <h2>文物遗产自动化监测</h2>
        <div class="all">
          <p>
              文物作为一个国家、一个民族文明程度的有效载体，代表着国家的历史和底蕴，显示着民族的渊源和风采。古建筑的健康监测研究 不仅是为古建筑加固保护提供定性与定量分析的工具，也是古建筑遗产管理工作的重要组成部分。根据世界文化遗产委员会以及我 国政府对世界文化遗产地监测工作的要求，古建筑的健康监测与保护是势在必行的。

          </p>
        </div>
        <div class="brief_box">

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>项目基本情况</h5>
            </div>
            <p>通过对文物的变形和环境进行监测，为科研、文物保护提供分析 依据和建议。</p>
             
              <div class="title_box row">
                <div class="blue_line"></div>
                <h5>监测参数</h5>
            </div>
            <p>表面位移（GNSS/测量机器人）</p>
            <p>建筑沉降（静力水准）</p>
            <p>深部位移（多点位移计）</p>
            <p>支护结构（钢筋计/锚索计）</p>
            <p>裂缝（裂缝计）</p>
            <p>地下水（渗压计）</p>
            <p>倾斜监测（测量机器人/倾斜仪）</p>
            <p>受力分析（应力计/应变计）</p>
            <p>气象环境（气象站）</p>
            <p>地震（加速度传感器）</p>
            <p>视频（视频系统）</p>

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>推荐设备</h5>
            </div>
            <p>监测设备：</p>
            <p>RocBox RT2000-GS北斗监测GNSS</p>
            <p>Topcon MS/DS系列测量机器人</p>
            <p>RT-DT-5100液压式静力水准</p>
            <p>RT-VW-4300振弦式多点位移计</p>
            <p>RT-VW-2300振弦式钢筋计</p>
            <p>RT-VW-4100振弦式裂缝计</p>
            <p>RT-VW-3100振弦式渗压计</p>
            <p>RT-DT-6300测斜仪</p>
            <p>RT-VW-1200振弦式表面应变计</p>
            <p>RT-DT-8100系列多参数气象站</p>
            <p>低频测振传感器</p>
            
            <h6>监测终端:</h6>
            <p>RocBox RT2000监测终端</p> 
            <p>RocMIoT监测物联网系列产品</p>  
            <p>振动信号采集仪</p>  
</p>              
        </div>    
    </div>
     <foot></foot>

</div>

</template>
<style>
.relic {
  width: 100%;
  background-color: rgba(245, 245, 245, 1);
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  margin-top: 0.55rem;
  margin-bottom: 0.36rem;
}
.all {
  width: 11.4rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 0.3rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.brief_box {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-top: 0.2rem;
  margin-bottom: 0.67rem;
  padding-bottom: .64rem;
}
.brief_box p,
 .brief_box h6{
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.4rem;
  padding-top: 0.1rem;
}
.brief_box h6{
    padding-top: .3rem;
}
.title_box {
  margin-left: 0.4rem;
  margin-top: 0.37rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.2rem;
}
.blue_line {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/solutionpage/relic.vue